import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Button } from 'react-bootstrap';

const PageNotFound = () => {
  return (
    <Container className="d-flex align-items-center justify-content-center vh-100">
      <Row className="text-center">
        <Col>
          <h1 className="display-1 text-white">404</h1>
          <p className="mb-2 h2">
            <span className="text-light">Oops!</span> <span className="text-white">Page not found</span>
          </p>
          <p className="mb-3 text-white">The page you’re looking for doesn’t exist.</p>
          <Link to={"/"}>
            <Button variant="light">Go Home</Button>
          </Link>
        </Col>
      </Row>
    </Container>
  );
};

export default PageNotFound;